import TitleSearchCollection from "pages/file/components/product-section/title-search/TitleSearchCollection";
import AALProductCollection from "pages/file/components/product-section/aal/AALProductCollection";
import CPLProductCollection from "pages/file/components/product-section/cpl/CPLProductCollection";
import JacketProductCollection from "pages/file/components/product-section/jacket/JacketProductCollection";
import StandAloneCollection from "pages/file/components/product-section/standalone/StandAloneCollection";
import PolicyUpload from "pages/file/components/product-section/policy-upload/PolicyUpload";
import UWACollection from "pages/file/components/product-section/uwa/UWACollection";

const tabMapping = {
  TitleSearchCollection,
  AALProductCollection,
  CPLProductCollection,
  JacketProductCollection,
  StandAloneCollection,
  UWACollection,
  PolicyUpload,
};

export { tabMapping };
